export const MessageSentiments = {
	interested: 'Interested',
	potentiallyInterested: 'Potentially Interested',
	notInterested: 'Not Interested',
	maybe: 'Maybe',
	ongoingConversations: 'Ongoing Conversations',
	inProgress: 'In Progress',
};
